import { PayloadAction } from "@reduxjs/toolkit";
import { FinanceState } from "../../models/FinanceState";
import { CreateMoneyTransferPayload } from "../../payload/CreateMoneyTransfer/CreateMoneyTransferPayload";

const createMoneyTransferFetch = (state: FinanceState, action: PayloadAction<CreateMoneyTransferPayload>) => {
    state.isLoading = true;
}

export default createMoneyTransferFetch;